import { render } from "./ProductViewmode.vue?vue&type=template&id=4c58727a&scoped=true"
import script from "./ProductViewmode.vue?vue&type=script&lang=js"
export * from "./ProductViewmode.vue?vue&type=script&lang=js"

import "./ProductViewmode.vue?vue&type=style&index=0&id=4c58727a&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c58727a"]])

export default __exports__